import moment from 'moment';
import _ from 'lodash';

import { ManagePurchaseOrderEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { ItemEnum } from 'Common/FieldEnum';
import { KitchenItemPrepareInHouseFilterEnum } from 'Common/GridHelper';

import * as types from './types';

const INITIAL_STATE = {
  purchaseOrderListData: {
    GetData: [],
    Errors: [],
  },
  loading: false,
  fetchingSites: false,
  closing: false,
  printLoading: false,
  printError: null,
  fetchEditPOWODetail: false,
  selectedOrderDetail: null,
  fetchEditPOWOItems: false,
  editPOWOItems: [],
  editPOWOItemsLoadingError: null,
  editPOWOLoadingError: null,
  submitting: false,
  submitted: false,
  submitError: null,
  eleFileData: [],
  eleFileDownloadMsg: '',
  deletePOWOReceiptLoading: false,
  deleteError: null,
  fromDateMax: moment().add(1, 'month'),
  toDateMin: moment().subtract(1, 'month'),
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.PURCHASE_ORDER_LIST: {
      return {
        ...state,
        purchaseOrderListData: {
          ...state.purchaseOrderListData,
          GetData: action.payload.map(item => ({
            ...item,
            [ManagePurchaseOrderEnum.OrderDT]: item[
              ManagePurchaseOrderEnum.OrderDT
              ]
              ? moment(item[ManagePurchaseOrderEnum.OrderDT]).format(
                DATE_FORMAT_FOR_UI
              )
              : '',
            [ManagePurchaseOrderEnum.OrderTypeName]: item[
              ManagePurchaseOrderEnum.OrderTypeName
              ]
              ? item[ManagePurchaseOrderEnum.OrderTypeName].join(',')
              : '',
            [ManagePurchaseOrderEnum.DeliveryDT]: item[
              ManagePurchaseOrderEnum.DeliveryDT
              ]
              ? moment(item[ManagePurchaseOrderEnum.DeliveryDT]).format(
                DATE_FORMAT_FOR_UI
              )
              : '',
          })),
        },
      };
    }
    case types.PURCHASE_ORDER_CHECKALL_ITEMS_DATA: {
      const copiedData = _.cloneDeep(state.purchaseOrderListData.GetData);
      copiedData.forEach(x => {
        const foundRow = _.find(action.payload.currentRows, {
          ReceiptId: x.ReceiptId,
        });
        if (foundRow) {
          x.Allowed = action.payload.checkAll;
        }
      });
      return {
        ...state,
        purchaseOrderListData: {
          ...state.purchaseOrderListData,
          GetData: copiedData,
        },
      };
    }
    case types.PURCHASE_ORDER_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case types.PURCHASE_ORDER_UPDATE_ITEMS_DATA: {
      const copiedData = _.cloneDeep(state.purchaseOrderListData.GetData);
      const item = _.find(copiedData, {
        ReceiptId: action.payload.ReceiptId,
      });

      if (!item) {
        return state;
      }

      item.Allowed = !action.payload.Allowed;

      return {
        ...state,
        purchaseOrderListData: {
          ...state.purchaseOrderListData,
          GetData: copiedData,
        },
      };
    }
    case types.PURCHASE_ORDER_LOADING_ONCLOSE:
      return {
        ...state,
        closing: action.payload,
      };

    case types.PURCHASE_ORDER_ERROR:
      const purchaseOrderErrorResponse = action.payload.response;
      if (
        _.has(purchaseOrderErrorResponse, 'data.Errors') &&
        purchaseOrderErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          purchaseOrderListData: {
            ...state.purchaseOrderListData,
            Errors: purchaseOrderErrorResponse.data.Errors,
          },
        };
      }

      return {
        ...state,
        purchaseOrderListData: {
          ...state.purchaseOrderListData,
          Errors: [
            {
              Title: TitleEnum.Error,
              Message:
                'An error occurred while closing item(s). Please try again.',
            },
          ],
        },
      };

    case types.PURCHASE_ORDER_PRINT_LOADING:
      return {
        ...state,
        printLoading: action.payload,
      };

    case types.PURCHASE_ORDER_PRINT_ERROR:
      const printOrderResponse = action.payload.response;
      if (
        _.has(printOrderResponse, 'data.Errors') &&
        printOrderResponse.data.Errors.length
      ) {
        return {
          ...state,
          printError: printOrderResponse.data.Errors,
        };
      }
      return {
        ...state,
        printError: {
          Title: TitleEnum.Error,
          Message: 'An error occurred while creating PDF. Please try again.',
        },
      };

    case types.CLEAR_PURCHASE_ORDER_ERROR:
      return {
        ...state,
        printError: null,
        editPOWOItemsLoadingError: null,
        editPOWOLoadingError: null,
        submitError: null,
        deleteError: null,
      };

    case types.EDIT_PO_WO_LOADING:
      return {
        ...state,
        fetchEditPOWODetail: action.payload,
      };
    case types.EDIT_PO_WO_DETAIL:
      let selectedOrderDetail = null;
      if (action.payload) {
        selectedOrderDetail = { ...action.payload };
        selectedOrderDetail.POItemDetails = selectedOrderDetail.POItemDetails.map(
          item => ({
            ...item,
            [ItemEnum.BeginDate]: item[ItemEnum.BeginDate]
              ? moment(item[ItemEnum.BeginDate]).format(DATE_FORMAT_FOR_UI)
              : '',
            [ItemEnum.EndDate]: item[ItemEnum.EndDate]
              ? moment(item[ItemEnum.EndDate]).format(DATE_FORMAT_FOR_UI)
              : '',
            [ItemEnum.PrepareInHouse]: item[ItemEnum.PrepareInHouse]
              ? KitchenItemPrepareInHouseFilterEnum.Yes
              : KitchenItemPrepareInHouseFilterEnum.No,
          })
        );
      }
      return {
        ...state,
        selectedOrderDetail,
      };
    case types.EDIT_PO_WO_LOADING_ERROR:
      const editPOWPLoadingResponse = action.payload.response;
      if (
        _.has(editPOWPLoadingResponse, 'data.Errors') &&
        editPOWPLoadingResponse.data.Errors.length
      ) {
        return {
          ...state,
          editPOWOLoadingError: editPOWPLoadingResponse.data.Errors,
        };
      }
      return {
        ...state,
        editPOWOLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching PO/WO Detail. Please try again.',
        },
      };
    case types.EDIT_PO_WO_ITEMS_LOADING:
      return {
        ...state,
        fetchEditPOWOItems: action.payload,
      };
    case types.EDIT_PO_WO_ITEMS: {
      return {
        ...state,
        editPOWOItems: action.payload.map(item => ({
          ...item,
          [ItemEnum.BeginDate]: item[ItemEnum.BeginDate]
            ? moment(item[ItemEnum.BeginDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.EndDate]: item[ItemEnum.EndDate]
            ? moment(item[ItemEnum.EndDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.PriQty]: null,
          [ItemEnum.SecQty]: null,
          [ItemEnum.PrepareInHouse]: item[ItemEnum.PrepareInHouse]
            ? KitchenItemPrepareInHouseFilterEnum.Yes
            : KitchenItemPrepareInHouseFilterEnum.No,
        })),
      };
    }
    case types.EDIT_PO_WO_ITEMS_LOADING_ERROR:
      const editPOWOItemsLoadingResponse = action.payload.response;
      if (
        _.has(editPOWOItemsLoadingResponse, 'data.Errors') &&
        editPOWOItemsLoadingResponse.data.Errors.length
      ) {
        return {
          ...state,
          editPOWOItemsLoadingError: editPOWOItemsLoadingResponse.data.Errors,
        };
      }
      return {
        ...state,
        editPOWOItemsLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching PO/WO Items. Please try again.',
        },
      };
    case types.RE_ORDER_PO_WO_ITEM_LIST:
      let clone = _.clone(state.editPOWOItems, true);
      let remainedItem = [];
      if (action.payload && action.payload.length) {
        _.forEach(action.payload, item => {
          const index = _.findIndex(clone, function(cloneItem) {
            return item.ItemCode === cloneItem.ItemCode;
          });
          if (index !== -1) {
            remainedItem.push(clone[index]);
            clone.splice(index, 1);
          }
        });
      }
      clone = _.concat(remainedItem, clone);
      return {
        ...state,
        editPOWOItems: clone,
      };
    case types.SAVE_PO_WO_LOADING:
      return {
        ...state,
        submitting: action.payload,
      };
    case types.SAVE_PO_WO_SUBMIT:
      return {
        ...state,
        submitted: true,
      };
    case types.SUBMIT_PO_WO_DETAIL_ERROR:
      const submitResponse = action.payload.response;
      if (
        _.has(submitResponse, 'data.Errors') &&
        submitResponse.data.Errors.length
      ) {
        return {
          ...state,
          submitError: submitResponse.data.Errors,
        };
      }
      return {
        ...state,
        submitError: {
          Title: TitleEnum.Error,
          Message: 'An error occurred while saving Order. Please try again.',
        },
      };
    case types.CLEAR_PO_WO_ERROR_SUCCESS:
      return {
        ...state,
        submitted: false,
        submitError: null,
        deleteError: null,
      };
    case types.PURCHASE_ORDER_ELE_FILE_DOWNLOAD_SUCCESS:
      return {
        ...state,
        eleFileDownloadMsg: action.payload,
      };
    case types.DELETE_PO_WO_RECEIPT_LOADING:
      return {
        ...state,
        deletePOWOReceiptLoading: action.payload,
      };
    case types.DELETE_PO_WO_RECEIPT_LOADING_ERROR:
      const deleteResponse = action.payload.response;
      if (
        _.has(deleteResponse, 'data.Errors') &&
        deleteResponse.data.Errors.length
      ) {
        return {
          ...state,
          deleteError: deleteResponse.data.Errors,
        };
      }
      return {
        ...state,
        deleteError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while deleting Order(s). Please try again.',
        },
      };
    case types.SET_FROM_DATE_MAX:
      return {
        ...state,
        fromDateMax: action.payload,
      };
    case types.SET_TO_DATE_MIN:
      return {
        ...state,
        toDateMin: action.payload,
      };

    case types.PURCHASE_ORDER_SITE_LIST:
      return {
        ...state,
        siteListData: action.payload,
      };

    case types.FETCHING_SITES: {
      return {
        ...state,
        fetchingSites: action.payload,
      };
    }

    case types.FETCH_ALL_SITE_ERROR:
      const fetSiteErrorResponse = action.payload.response;
      if (
        _.has(fetSiteErrorResponse, 'data.Errors') &&
        fetSiteErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          fetchingAllSiteError: fetSiteErrorResponse.data.Errors,
        };
      }
      return {
        ...state,
        fetchingAllSiteError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while retrieving all sites. Please try again.',
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/state/managePurchasseOrder/reducer.js